import { IconPlayerStop } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Box, Button } from '@mantine/core';
import ConfirmationModal from '../Modals/ConfirmationModal';

const AbTestStopElement = ({ abTest, stopAbTest }) => {
  const [confirmStop, setConfirmStop] = useState(false);

  return (
    <>
      <Button
        type="button"
        size="xs"
        onClick={() => {
          setConfirmStop(true);
        }}
      >
        <IconPlayerStop size={14} />
        <Box component="span" visibleFrom="md" display="inline"> Stop</Box>
      </Button>
      <ConfirmationModal
        show={confirmStop}
        close={() => setConfirmStop(false)}
        confirm={() => {
          stopAbTest(abTest.id);
          setConfirmStop(false);
        }}
        message="Are you sure you want to stop the A/B test?"
      />
    </>
  );
};

export default AbTestStopElement;
